import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/star.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm star [<package-spec>...]
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/star.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <p>{`Note: This command is unaware of workspaces.`}</p>
    <h3>{`Description`}</h3>
    <p>{`"Starring" a package means that you have some interest in it.  It's
a vaguely positive way to show that you care.`}</p>
    <p>{`It's a boolean thing. Starring repeatedly has no additional effect.`}</p>
    <h3>{`More`}</h3>
    <p>{`There's also these extra commands to help you manage your favorite packages:`}</p>
    <h4>{`Unstar`}</h4>
    <p>{`You can also "unstar" a package using `}<a parentName="p" {...{
        "href": "/cli/v8/commands/npm-unstar"
      }}><inlineCode parentName="a">{`npm unstar`}</inlineCode></a></p>
    <p>{`"Unstarring" is the same thing, but in reverse.`}</p>
    <h4>{`Listing stars`}</h4>
    <p>{`You can see all your starred packages using `}<a parentName="p" {...{
        "href": "/cli/v8/commands/npm-stars"
      }}><inlineCode parentName="a">{`npm stars`}</inlineCode></a></p>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`registry`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: "`}<a parentName="li" {...{
          "href": "https://registry.npmjs.org/%22"
        }}>{`https://registry.npmjs.org/"`}</a></li>
      <li parentName="ul">{`Type: URL`}</li>
    </ul>
    <p>{`The base URL of the npm registry.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`unicode`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false on windows, true on mac/unix systems with a unicode locale,
as defined by the `}<inlineCode parentName="li">{`LC_ALL`}</inlineCode>{`, `}<inlineCode parentName="li">{`LC_CTYPE`}</inlineCode>{`, or `}<inlineCode parentName="li">{`LANG`}</inlineCode>{` environment variables.`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`When set to true, npm uses unicode characters in the tree output. When
false, it uses ascii characters instead of unicode glyphs.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`otp`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null or String`}</li>
    </ul>
    <p>{`This is a one-time password from a two-factor authenticator. It's needed
when publishing or changing package permissions with `}<inlineCode parentName="p">{`npm access`}</inlineCode>{`.`}</p>
    <p>{`If not set, and a registry response fails with a challenge for a one-time
password, npm will prompt on the command line for one.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/package-spec"
        }}>{`package spec`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-unstar"
        }}>{`npm unstar`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-stars"
        }}>{`npm stars`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-view"
        }}>{`npm view`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-whoami"
        }}>{`npm whoami`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-adduser"
        }}>{`npm adduser`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      